export const TelephoneInterviewIcon = () => (
    <svg
        viewBox="0 0 10 40"
        width={'22%'}
        height={'60%'}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M35 25v6.55a3.333 3.333 0 0 1-3.817 3.333A30 30 0 0 1 5.233 8.817 3.333 3.333 0 0 1 8.55 5H15a1.667 1.667 0 0 1 1.667 1.483c.165 2.185.73 4.32 1.666 6.3a1.667 1.667 0 0 1-.7 2.1L16.2 15.7a1.666 1.666 0 0 0-.55 2.433 23.467 23.467 0 0 0 6.15 6.15 1.666 1.666 0 0 0 2.433-.55l.817-1.433a1.667 1.667 0 0 1 2.167-.633 17.901 17.901 0 0 0 6.3 1.666A1.667 1.667 0 0 1 35 25ZM35 15A10 10 0 0 0 25 5M25 11.667A3.333 3.333 0 0 1 28.333 15"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
);
